import { useState, ReactNode, useEffect } from 'react';

import classnames from 'classnames';

import styles from './SteppedForm.module.css';

const SteppedForm = ({
  head,
  children,
  open,
  canOpen = true,
}: {
  head: ReactNode;
  children: ReactNode;
  open?: boolean;
  canOpen?: boolean;
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    if (open !== undefined) {
      setIsOpen(open);
    }
  }, [open]);

  return (
    <div className={styles.steppedFormElement}>
      <button
        className={classnames(styles.button, {
          [styles.selectedContainer]: isOpen,
        })}
        onClick={() => setIsOpen(canOpen && !isOpen)}
      >
        <div
          className={classnames(styles.titleContent, {
            [styles.selectedTitle]: isOpen,
          })}
        >
          {head}
        </div>
      </button>
      {isOpen && <div className={styles.bodyContainer}>{children}</div>}
    </div>
  );
};

export { SteppedForm };
